import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';

//redux
import ReceptionGuide from './ReceptionGuide/ReceptionGuide';
import { icon } from 'leaflet';

const WarehouseReception = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Medio Ambiente', icon:'icon-leaf' },
		{ to: '/residue/dashboard', label: 'Residuos', icon: 'icon-recycle' },
		{ to: '#', label: 'Bodega', icon: 'icon-warehouse' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Recepción Bodega' links={breadcrumbLinks} icon={'icon-package'} />
					<ReceptionGuide/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default WarehouseReception;
